import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        field: {
            paddingBottom: theme.spacing(),
        },
        root: {
            marginTop: 6,
        },
    });
});
